import {InternalLinkOption} from "../option"
import {LexicalEditor} from "lexical"
import {lexicalChangeList} from "../../../actions/change-list"
import {PopoverMenuItemType} from "../../../../popover-menu/popover-menu/const"
import slashMenu_iconComponent from "./slah-menu-icon-component"

export default function editor_listOptions(editor: LexicalEditor, blockType: any) {

    const bulletList = new InternalLinkOption('Bullet list', {
        id              : 'bulletList',
        // icon            : 'editor-i5-bullet-list fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-bullet-list'),
        keywords        : ['bullet', 'list'],
        action          : () => {
            lexicalChangeList(editor, blockType, 'bullet')
        }
    })

    const numberedList = new InternalLinkOption('Numbered list', {
        id              : 'numberedList',
        // icon            : 'editor-i5-numbered-list fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-numbered-list'),
        keywords        : ['number', 'list'],
        action          : () => {
            lexicalChangeList(editor, blockType, 'number')
        }
    })

    const checkList = new InternalLinkOption('Check list', {
        id              : 'checkList',
        // icon            : 'editor-i5-check-list fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-check-list'),
        keywords        : ['check', 'list'],
        action          : () => {
            lexicalChangeList(editor, blockType, 'check')
        }
    })

    const options = [
        bulletList,
        numberedList,
        checkList,
    ]

    let optionsBlockKeywords: string[] = []
    _.map(options, option=>optionsBlockKeywords = optionsBlockKeywords.concat(option.keywords))

    return [
        new InternalLinkOption('List', {
            type        : PopoverMenuItemType.HEADER,
            keywords    : optionsBlockKeywords
        }),

        ...options,

        new InternalLinkOption('', {
            type        : PopoverMenuItemType.SEPARATOR,
            keywords    : optionsBlockKeywords
        }),
    ]
}